// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Nlu0","clinicsSelect":"styles_clinicsSelect__2O2Ed"};